import MutateApiHookType from '@trinsly/common/src/types/mutate-api-hook-type'
import { useMutation, useQueryClient } from 'react-query'
import cancelAllUnsentThreadsService from 'services/cancel-all-unsent-threads-service'
import ThreadType from 'types/thread-type'

export type UseCancelAllUnsentThreadsProps = {} & MutateApiHookType<
  ThreadType[]
>
function useCancelAllUnsentThreads({
  onMutate,
  onSuccess,
  onError,
}: UseCancelAllUnsentThreadsProps) {
  const queryClient = useQueryClient()

  const { mutate: fetch, isLoading: pending } = useMutation(
    cancelAllUnsentThreadsService,
    {
      onSuccess: async (data) => {
        await queryClient.invalidateQueries('/threads')
        onSuccess?.(data)
      },
      onError,
      onMutate,
    }
  )

  return {
    fetch,
    pending,
  }
}

export default useCancelAllUnsentThreads
